import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format a number as currency with thousands separators
 * @param amount - The number to format
 * @returns Formatted currency string without currency symbol
 */
export function formatCurrency(amount: number | null): string {
  if (amount === null || amount === 0) {
    return '0.00';
  }
  return new Intl.NumberFormat('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
